import React from 'react';
import './pages.css';
import Header from '../components/Header';
import About from '../components/About';
import HomeService from '../components/HomeService';
import Services from '../components/Services';
import VehicleSlider from '../components/VehicleSlider';
import Reviews from '../components/Reviews';
import Parallax from '../components/Parallax';
import Videos from '../components/Videos';
import Contact from '../components/Contact';

const Accueil = () => {
  return (
    <div>
      <Header />
      <About />
      <Parallax />
      <HomeService />
      <Services />
      <Videos />
      <VehicleSlider />
      <Contact />
      <Reviews />
    </div>
  );
};

export default Accueil;
